import React, { useEffect, useRef, useState } from 'react';
import styles from '../../assets/css/ebook.module.css';
import { HeroBannerProps } from './type';
import Formulario from '../Formulario';

const HeroBanner: React.FC<HeroBannerProps> = ({
    logoSrc,
    logoAlt = 'Logotipo',
    title,
    highlightWord,
    subtitle,
    ctaText,
    ctaHref,
    onCtaClick,
    badgeText,
    imageSrc,
    imageAlt = 'Imagem ilustrativa',
}) => {
    const [showFormulario, setShowFormulario] = useState(false);
    const [selectOption, setSelectOption] = useState<string | undefined>(undefined);
    const formularioRef = useRef<HTMLDivElement>(null);

    // Quando o formulário abrir, rola a tela até ele
    useEffect(() => {
        if (showFormulario && formularioRef.current) {
            formularioRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [showFormulario]);

    const renderTitle = (): React.ReactNode => {
        if (!highlightWord) return title;

        const startIndex = title.indexOf(highlightWord);
        if (startIndex === -1) return title;

        const before = title.slice(0, startIndex);
        const after = title.slice(startIndex + highlightWord.length);

        return (
            <>
                {before}
                <span className={styles.highlight}>{highlightWord}</span>
                {after}
            </>
        );
    };

    const handleCtaClick = (e: React.MouseEvent) => {
        e.preventDefault(); // evita navegação caso esteja usando ctaHref
        setShowFormulario(true);
        onCtaClick?.();
    };

    const handleCloseFormulario = () => {
        setShowFormulario(false);
    };

    return (
        <>
            <section className={styles.banner}>
                <header className={styles.header}>
                    <img src={logoSrc} alt={logoAlt} className={styles.logo} />
                </header>

                <div className={styles.content}>
                    <div className={styles.textColumn}>
                        <h1 className={styles.title}>{renderTitle()}</h1>
                        <p className={styles.subtitle}>{subtitle}</p>

                        {ctaHref ? (
                            
                               <a href={ctaHref}
                                className={styles.ctaButton}
                                onClick={handleCtaClick}
                            >
                                {ctaText}
                            </a>
                        ) : (
                            <button
                                id="btn-ebook"
                                type="button"
                                className={styles.ctaButton}
                                onClick={handleCtaClick}
                            >
                                {ctaText}
                            </button>
                        )}

                        {badgeText && <span className={styles.badge}>{badgeText}</span>}
                    </div>

                    <div className={styles.imageColumn}>
                        <img src={imageSrc} alt={imageAlt} className={styles.image} />
                    </div>
                </div>
            </section>

            {showFormulario && (
                <section ref={formularioRef} className={styles.banner}>
                    <div className={styles.form}>
                        <Formulario
                        selectOption={selectOption}
                        setSelectOption={setSelectOption}
                        handleClose={handleCloseFormulario} selectedOption={undefined}                    />
                    </div>
                </section>
            )}
        </>
    );
};

export default HeroBanner;